export default "__VITE_ASSET__BN$kvX2N__"